import { render, staticRenderFns } from "./admin-password.vue?vue&type=template&id=2ed2aa68&"
import script from "./admin-password.vue?vue&type=script&lang=ts&"
export * from "./admin-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports